import { render, staticRenderFns } from "./FeriadoDetalhar.vue?vue&type=template&id=4d27f0a5"
import script from "./FeriadoDetalhar.vue?vue&type=script&lang=js"
export * from "./FeriadoDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports